import React, { useCallback, useReducer, useState, useContext } from 'react';
import { useDropzone } from 'react-dropzone';
import useTranslations from '../../hooks/useTranslations';
import FileUploadView from '../view/FileUploadView';
import useGlobalVariables from '../../hooks/useGlobalVariables';
import { FetchCallbacksContext } from '../../internal-components/FetchCallbacks';
import { setFilters } from '../../store/modules/state/gridFilters';

const initialState = {
  progress: 0
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'reset':
      return {
        ...initialState,
        reset: state.reset + 1
      };
    case 'progress':
      return { ...state, progress: payload };
    default:
      return { ...state };
  }
};

const defaultAcceptedTypes = [
  'doc',
  'docx',
  'pdf',
  'png',
  'jpg',
  'txt',
  'csv',
  'xls',
  'xlsx'
];

const FileUploadEngine = ({
  acceptedTypes = defaultAcceptedTypes,
  onFileDropped = () => {},
  existingFiles = [],
  belowButtonBlock = ''
}) => {
  const { setIsLoading } = useGlobalVariables();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { openSnackbar } = useContext(FetchCallbacksContext);
  const t = useTranslations();
  const [attachments, setAttachments] = useState(existingFiles);

  const onDrop = useCallback(
    ([file]) => {
      // validate file extension
      const fileType = (file.name.split('.').slice(-1)[0] || '').toLowerCase();

      if (!acceptedTypes.includes(fileType)) {
        openSnackbar('error', 'Invalid file type', true);
        return;
      }

      onFileDropped(file);
      setAttachments([file]);
    },
    [acceptedTypes, onFileDropped]
  );

  const dropzone = useDropzone({ onDrop, noClick: true });

  const onDropZoneClicked = useCallback(event => {
    dropzone.open();
  }, []);

  const viewProps = {
    attachments,
    belowButtonBlock,
    dropzone,
    onDropZoneClicked
  };

  return <FileUploadView {...viewProps} />;
};

export default FileUploadEngine;
